import * as yup from "yup";
import { yupHelper } from "lib/helpers";

const { emailRegex, handleBrandRegex, postalCodeRegex, provinceCodeRegex, phoneNumberRegex } = yupHelper;

const firstNameSchema = (cms) =>
  yup.object().shape({
    firstName: yup.string().required(cms("common.message.error.firstNameIsRequired")),
  });

const lastNameSchema = (cms) =>
  yup.object().shape({
    lastName: yup.string().required(cms("common.message.error.lastNameIsRequired")),
  });

const emailSchema = (cms) =>
  yup.object({
    email: yup
      .string()
      .required(cms("common.message.error.emailIsRequired"))
      .matches(emailRegex, cms("common.message.error.enterValidEmail")),
  });

const phoneNumberSchema = (cms) =>
  yup.object().shape({
    phoneNumber: yup
      .string()
      .required(cms("common.message.error.phoneNumberIsRequired"))
      .matches(phoneNumberRegex, cms("common.message.error.positiveNumber"))
      .min(7, cms("common.message.error.minPhoneNumber"))
      .max(15, cms("common.message.error.maxPhoneNumber")),
  });

const provinceCodeSchema = (cms) =>
  yup.object().shape({
    provinceCode: yup
      .string()
      .required(cms("common.message.error.provinceCode"))
      .matches(provinceCodeRegex, {
        message: cms("common.message.error.enterValidProvinceCode"),
      }),
  });

const citySchema = (cms) =>
  yup.object().shape({
    city: yup.string().required(cms("common.message.error.cityIsRequired")),
  });

const mailSubjectSchema = (cms) =>
  yup.object().shape({
    mailSubject: yup.string().required(cms("common.message.error.subject")),
  });

const countrySchema = (cms) =>
  yup.object().shape({
    country: yup.string().required(cms("common.message.error.countryIsRequired")),
  });

const postalCodeSchema = (cms, schema) => {
  const { min = 2 } = schema || {};
  return yup.object().shape({
    postalCode: yup
      .string()
      .required(cms("common.message.error.postalCodeIsRequired"))
      .matches(postalCodeRegex, cms("common.message.error.alphanumeric"))
      .min(min, cms("common.message.error.minPostalCode", { min }))
      .max(32, cms("common.message.error.maxPostalCode"))
      .nullable(),
  });
};

const streetAddressSchema = (cms) =>
  yup.object().shape({
    streetAddress: yup.string().required(cms("common.message.error.streetAddressIsRequired")),
  });

const brandNameSchema = (cms) =>
  yup.object().shape({
    brandName: yup.string().required(cms("common.message.error.brandNameIsRequired")),
  });

const brandHandleSchema = (cms) => {
  return yup.object({
    brandHandle: yup
      .string()
      .required(cms("common.message.error.brandHandle.required"))
      .matches(handleBrandRegex, cms("common.message.error.brandHandle.match")),
  });
};

export {
  brandHandleSchema,
  brandNameSchema,
  citySchema,
  countrySchema,
  emailSchema,
  firstNameSchema,
  lastNameSchema,
  mailSubjectSchema,
  phoneNumberSchema,
  postalCodeSchema,
  provinceCodeSchema,
  streetAddressSchema,
};
